__turbopack_context__.v({
  "contentPage": "PageContent-module-scss-module__vdUNcq__contentPage",
  "fade-in": "PageContent-module-scss-module__vdUNcq__fade-in",
  "landingPage": "PageContent-module-scss-module__vdUNcq__landingPage",
  "no-transform": "PageContent-module-scss-module__vdUNcq__no-transform",
  "pageContent": "PageContent-module-scss-module__vdUNcq__pageContent",
  "rotate": "PageContent-module-scss-module__vdUNcq__rotate",
});
